import { useCallback, useMemo, useState } from "react";
import clsx from "clsx";
import { useStore } from "../../../../stores";
import locale from "../../../../constants/locale";
import { toast } from "bulma-toast";
import { useTranslation } from "react-i18next";
import { safeParse } from "../../../../utils/arrays";
import { LuGhost } from "react-icons/lu";

export default function GuestUserAdmin({ isResponsive = false }) {
  const { t } = useTranslation();
  const { userHasAdminAccess, user } = useStore("auth");
  const { updateGuestUsers, selectedChat } = useStore("chats");
  const [loading, setLoading] = useState(false);

  const guestUsers = useMemo(
    () => safeParse(selectedChat?.data?.guest_users) ?? [],
    [selectedChat?.data?.guest_users]
  );
  const isAdminConnectedAsGuest = guestUsers.includes(user?.id);

  const onSubmit = useCallback(async () => {
    try {
      setLoading(true);

      await updateGuestUsers([...guestUsers, user?.id]);

      toast({
        message: t(locale.messageGuestUserUpdateSuccess),
        position: "top-right",
        dismissible: true,
        type: "is-success",
        pauseOnHover: true,
      });
    } catch (e) {
      console.log("error", e);
      toast({
        message: t(locale.genericError),
        position: "top-right",
        dismissible: true,
        type: "is-danger",
        pauseOnHover: true,
      });
    } finally {
      setLoading(false);
    }
  }, [guestUsers, updateGuestUsers, t, user?.id]);

  if (
    !userHasAdminAccess ||
    !selectedChat?.isConnected ||
    isAdminConnectedAsGuest ||
    selectedChat?.userConnected === user?.id
  ) {
    return null;
  }

  return (
    <button
      className={clsx("button is-rounded has-text-primary", {
        "is-loading": loading,
        "is-ghost no-focus": isResponsive,
      })}
      disabled={loading}
      onClick={onSubmit}
    >
      <span style={{ position: "absolute" }} className="icon">
        <LuGhost color="#9AA1C3" size={18} />
      </span>
    </button>
  );
}
